import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { ToggleSwitch } from "MODULES/shared/containers";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import { hasRole } from "MODULES/users/helpers";
import { SALES } from "MODULES/users/constants";
import Form from "./Form";

const excludedQuoteTypes = ["awaiting_info_to_complete", "offer"];

function filteredLineItems(quote) {
  return quote.outgoing_quote_line_items.filter(
    i => !excludedQuoteTypes.includes(i.quote_type)
  );
}

function AutoFollowup({ quote, currentUser }) {
  const disabled =
    !hasRole(currentUser, SALES) ||
    quote.cancelled ||
    quote.received ||
    filteredLineItems(quote).length <= 0;

  return (
    <ToggleSwitch>
      {(visible, open, close) => (
        <DropDownItem onClick={open} disabled={disabled}>
          <Icon name="repeat" fixed />
          &nbsp;Auto Follow Up
          <Modal open={visible} close={close} dialogClass="modal-lg">
            <Header>
              <Close close={close} />
              <h4 className="modal-title">Auto Follow Up</h4>
            </Header>
            <Form close={close} quote={quote} currentUser={currentUser} />
          </Modal>
        </DropDownItem>
      )}
    </ToggleSwitch>
  );
}

AutoFollowup.propTypes = {
  quote: T.instanceOf(Map).isRequired,
  ...WithCurrentUser
};

export default withCurrentUser(AutoFollowup);



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/Detail/AutoFollowup/AutoFollowup.jsx